import { render, staticRenderFns } from "./SpineScience.vue?vue&type=template&id=40b6a986&scoped=true"
import script from "./SpineScience.vue?vue&type=script&lang=js"
export * from "./SpineScience.vue?vue&type=script&lang=js"
import style0 from "./SpineScience.vue?vue&type=style&index=0&id=40b6a986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6a986",
  null
  
)

export default component.exports